import { render, staticRenderFns } from "./Periodical.vue?vue&type=template&id=e0f9a43e&scoped=true&"
import script from "./Periodical.vue?vue&type=script&lang=js&"
export * from "./Periodical.vue?vue&type=script&lang=js&"
import style0 from "./Periodical.vue?vue&type=style&index=0&id=e0f9a43e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f9a43e",
  null
  
)

export default component.exports